import React from 'react';
import type { KitModule, ModuleTone } from '../types/landing';
const toneStyles: Record<ModuleTone, {
  cover: string;
  label: string;
  title: string;
  icon: string;
}> = {
  cream: {
    cover: 'bg-beige-100',
    label: 'text-petrol-700',
    title: 'text-petrol-900',
    icon: 'bg-petrol-700 text-cream'
  },
  coral: {
    cover: 'bg-terra-100',
    label: 'text-terra-700',
    title: 'text-terra-700',
    icon: 'bg-terra-500 text-cream'
  },
  mist: {
    cover: 'bg-sage-100',
    label: 'text-petrol-700',
    title: 'text-petrol-900',
    icon: 'bg-petrol-800 text-cream'
  },
  peach: {
    cover: 'bg-[#F6E1D3]',
    label: 'text-terra-700',
    title: 'text-terra-700',
    icon: 'bg-terra-300 text-petrol-900'
  },
  rose: {
    cover: 'bg-blush',
    label: 'text-terra-700',
    title: 'text-terra-700',
    icon: 'bg-terra-600 text-cream'
  },
  sage: {
    cover: 'bg-sage-300',
    label: 'text-petrol-800',
    title: 'text-petrol-900',
    icon: 'bg-petrol-700 text-cream'
  },
  sand: {
    cover: 'bg-beige-200',
    label: 'text-petrol-700',
    title: 'text-petrol-900',
    icon: 'bg-terra-500 text-cream'
  }
};
type ModuleCoverProps = {
  module: KitModule;
  size?: 'sm' | 'lg';
};
export function ModuleCover({
  module,
  size = 'sm'
}: ModuleCoverProps) {
  const t = toneStyles[module.tone];
  const Icon = module.icon;
  const lg = size === 'lg';
  if (module.cover) {
    return <div className="relative aspect-[3/4] w-full overflow-hidden rounded-l-sm rounded-r-lg bg-[#3a2a1f] shadow-[0_14px_24px_-16px_rgba(17,43,42,0.6)]" data-id="element-46" data-mp="1k8wqp3701mg4">
        <img src={module.cover} alt={`Portada del Módulo ${module.number}: ${module.title}${module.subtitle ? ` ${module.subtitle}` : ''}`} width={1100} height={1500} loading="lazy" decoding="async" sizes={lg ? '260px' : '(min-width: 640px) 140px, 27vw'} className="h-full w-full object-cover" data-id="element-47" data-mp="1tanto0a5nf6a" />
        <span className={`absolute inset-y-0 left-0 bg-black/20 ${lg ? 'w-2.5' : 'w-1.5'}`} aria-hidden="true" data-id="element-48" data-mp="3v3u2vxz9jv76" />
      </div>;
  }
  return <div className={`relative flex aspect-[3/4] w-full flex-col overflow-hidden rounded-l-sm rounded-r-lg shadow-[0_14px_24px_-16px_rgba(17,43,42,0.6)] ${t.cover} ${lg ? 'p-5 sm:p-6' : 'p-2.5'}`} data-id="element-49" data-mp="1u0kwwxut2u9k">
      <span className={`absolute inset-y-0 left-0 bg-petrol-900/15 ${lg ? 'w-2.5' : 'w-1.5'}`} aria-hidden="true" data-id="element-50" data-mp="23xpm76jy75ul" />
      <p className={`text-center font-bold uppercase ${t.label} ${lg ? 'text-[11px] tracking-[0.18em]' : 'text-[8px] tracking-[0.12em]'}`} data-id="element-51" data-mp="28y3gzmwjgjao">
        Módulo {module.number}
      </p>
      <p className={`mt-1.5 text-center font-serif uppercase ${t.title} ${lg ? 'text-2xl leading-[1.05] sm:text-[1.7rem]' : 'text-[10.5px] leading-[1.1]'}`} data-id="element-52" data-mp="2hx8k76j1p0t6">
        {module.title}
        {module.subtitle && lg && <span className="mt-1 block text-[0.75em] leading-[1.1] opacity-90" data-id="element-53" data-mp="2rntg2m7c3r8e">{module.subtitle}</span>}
      </p>
      <span className={`mx-auto mt-auto flex items-center justify-center rounded-full ${t.icon} ${lg ? 'h-14 w-14' : 'h-7 w-7'}`} data-id="element-54" data-mp="2wno7cqv0uitz">
        <Icon className={lg ? 'h-6 w-6' : 'h-3.5 w-3.5'} aria-hidden="true" data-id="element-55" data-mp="30m5db72phn9t" />
      </span>
    </div>;
}